module.exports = __webpack_public_path__ + "static/media/ico-info.44cdc70b.svg";